<template>
  <div :class="componentClassName">
    <a-page-heading>利用明細</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card class="t-price-history-detail__card" title="ご利用料金一覧" icon="file">
        <m-price-table :title="tableTitle" :list="dataList" />
        <div class="t-price-history-detail__buttons">
          <m-button-container>
            <a-button variant="outlined" color="primary" @click="handleBackClick">戻る</a-button>
          </m-button-container>
        </div>
      </m-action-card>
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MPriceTable from '@/components/molecules/price-table';
import MButtonContainer from '@/components/molecules/button-container';
import AButton from '@/components/atoms/button';

export default {
  name: 't-price-history-detail',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    MPriceTable,
    MButtonContainer,
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    tableTitle: {
      type: String,
      default: '',
    },
    dataList: {
      type: Array,
      default: new Array(0),
    },
    handleBackClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-price-history-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
